import * as React from 'react';

import * as style from './style.sass';

interface Properties {
  value: number[];
  onChange: (value: number[]) => any;
}

export class DisabledIndices extends React.Component<Properties> {
  onDelete = (index: number) => {
    const { value, onChange } = this.props;
    const copy = [...value];
    const position = copy.indexOf(index);
    copy.splice(position, 1);
    onChange(copy);
  }

  render() {
    const { value } = this.props;

    return (<div className={style.disabledIndices}>
      <label>Disabled indices:</label>
      <div className={style.box}>
        {!value.length && <div className={style.none}>none</div>}
        {value.map(index => (<div
          className={style.item}
          onClick={this.onDelete.bind(this, index)}
        >
          {index} ❌
        </div>))}
      </div>
    </div>);
  }
}
